import React from 'react';
import store from '../../state';
import { Provider } from 'react-redux';
import PagerBulkTemplateApplyForm from './PagerBulkTemplateApplyForm';

const StandaloneWidget = props => (
  <Provider store={store}>
    <PagerBulkTemplateApplyForm {...props} />
  </Provider>
);

export default StandaloneWidget;
